import { render, staticRenderFns } from "./span-text.vue?vue&type=template&id=5873fc92&"
import script from "./span-text.vue?vue&type=script&lang=js&"
export * from "./span-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports